<template>
  <div class="asideCabinet">
    <router-link to="/" class="logo"><img src="@/assets/img/logo.png" alt=""></router-link>
    <div class="menu">
      <ul>
        <li>
          <router-link to="/cabinet/my-lombard">{{$t('my_pawnshop')}}</router-link>
        </li>
        <li>
          <router-link to="/cabinet/settings">{{$t('settings')}}</router-link>
        </li>
        <li>
          <router-link to="/cabinet/bonuses">{{$t('bonuses')}}</router-link>
        </li>
        <!-- <li>
          <router-link to="/cabinet/referral">{{$t('referral')}}</router-link>
        </li> -->
        <li>
          <router-link to="/">{{$t('back_site')}}</router-link>
        </li>
        <li><a href="#" @click="LogoutFunc()">{{$t('go_out')}}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'asideCabinet',
  data() {
    return {}
  },
  methods: {
    LogoutFunc() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('tickets');
      window.location.replace('/')
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/cabinet/asideCabinet.vue